import { render, staticRenderFns } from "./MainSidenav.vue?vue&type=template&id=4be96bbe"
import script from "./MainSidenav.vue?vue&type=script&lang=ts"
export * from "./MainSidenav.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports